import { Component, OnInit, inject } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Input } from '../../../../components/forms/input/input';
import { UiButtonComponent } from '../../../../components/button/button.component';
import { SettingService } from '../../../../services/setting/setting.service';
import { AppService } from '../../../../core/app.service';
import { ParametreRequest } from '../../../../data/http/requests/setting.req';
// Ajouts imports
import { UploadService } from '../../../../services/setting/upload.service'; // HYPOTHÈSE chemin, ajuster si différent
import { env } from '../../../../../env/env';

const TYPE_SYSTEM_CONFIG = 'SYSTEM_CONFIG';
const CODE_SIGLE = 'SIGLE';
const CODE_NOM_COMPLET = 'NOM_COMPLET';
const CODE_LOGO_PATH = 'LOGO_PATH';

@Component({
  selector: 'app-info-systeme',
  standalone: true,
  imports: [ReactiveFormsModule, Input, UiButtonComponent],
  templateUrl: './info-systeme.component.html',
  styleUrl: './info-systeme.component.scss'
})
export class InfoSystemeComponent implements OnInit {
  private fb = inject(FormBuilder);
  private settingService = inject(SettingService);
  private appService = inject(AppService);
  private uploadService = inject(UploadService);

  uploadFailed = false;
  uploadingLogo = false;
  uploadError: string | null = null;
  private logoPreview: string | null = null;

  form: FormGroup = this.fb.group({
    sigle: ['',],
    nomComplet: ['',],
    logoPath: [''], // HYPOTHÈSE — champ texte (chemin), pas un upload de fichier
  });

  loading = false;
  saving = false;
  private parametreId: string | null = null;
  private detailIds: Record<string, string | undefined> = {};
  private logoCacheBust = Date.now()

  ngOnInit(): void {
    this.loading = true;
    const appId = this.appService.getAppId();
    this.settingService.getByAppIdAndType(appId, TYPE_SYSTEM_CONFIG).subscribe({
      next: (res) => {
        const data = res.data;
        if (data) {
          this.parametreId = data.id;
          for (const d of data.listeDetailsParametres ?? []) {
            this.detailIds[d.code] = d.id;
            if (d.code === CODE_SIGLE) this.form.patchValue({ sigle: d.valeurAN });
            if (d.code === CODE_NOM_COMPLET) this.form.patchValue({ nomComplet: d.valeurAN });
            if (d.code === CODE_LOGO_PATH) this.form.patchValue({ logoPath: d.valeurAN });
          }
        }
        this.loading = false;
      },
      error: (err) => {
        // Pas de configuration existante pour cette application — première création
        console.error('Échec chargement config système', err);
        this.loading = false;
      }
    });
  }

  onLogoFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];
    if (!file) return;

    this.uploadError = null;
    this.uploadFailed = false;
    const previewCandidate = URL.createObjectURL(file);
    this.uploadingLogo = true;

    this.uploadService.uploadLogo(file).subscribe({
      next: (res) => {
        this.logoPreview = previewCandidate;
        this.form.patchValue({ logoPath: res.path });
        this.logoCacheBust = Date.now(); // ← ajout
        this.uploadingLogo = false;
      },
      error: (err) => {
        URL.revokeObjectURL(previewCandidate);
        this.uploadError = err?.error?.errors || "Format ou fichier non pris en charge.";
        this.uploadingLogo = false;
        this.uploadFailed = true;
        setTimeout(() => this.uploadFailed = false, 3000);
      }
    });

    input.value = '';
  }

  getLogoUrl(): string | null {
    if (this.logoPreview) return this.logoPreview;
    const path = this.form.get('logoPath')?.value;
    const base = this.settingService.buildLogoUrl(path);
    return base ? `${base}?t=${this.logoCacheBust}` : null;
  }

  onSubmit(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
    this.saving = true;
    const appId = this.appService.getAppId();
    const value = this.form.value;

    const request: ParametreRequest = {
      libelle: 'Configuration système',
      typeParametreCode: TYPE_SYSTEM_CONFIG,
      applicationId: appId,
      listeDetailsParametres: [
        { id: this.detailIds[CODE_SIGLE], code: CODE_SIGLE, valeurAN: value.sigle },
        { id: this.detailIds[CODE_NOM_COMPLET], code: CODE_NOM_COMPLET, valeurAN: value.nomComplet },
        { id: this.detailIds[CODE_LOGO_PATH], code: CODE_LOGO_PATH, valeurAN: value.logoPath },
      ],
    };

    const call = this.parametreId
      ? this.settingService.update(this.parametreId, request)
      : this.settingService.create(request);

    call.subscribe({
      next: (res) => {
        this.saving = false;
        if (res.data) {
          this.parametreId = res.data.id;
          for (const d of res.data.listeDetailsParametres ?? []) {
            this.detailIds[d.code] = d.id;
          }
        }
        this.settingService.refreshBrand(appId); // ← était invalidateBrandCache()
      },
      error: () => { this.saving = false; }
    });
  }
}